import React from "react";
import { Container } from "@mui/system";
import { ProductosAdmin } from "../../../components/Admin/Productos/Productos";

export const IndexProductosAdmin = () => {
    return(
        <Container maxWidth='xl'>
            <ProductosAdmin/> 
        </Container>
    )
}